import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, Ref } from 'vue';
import { useClickOutside } from '@/composables/clickOutside';
import { useColor } from '@/composables/color';
import ColorSelector from '../ColorSelector.vue';
import CalendarFieldTitle from './CalendarFieldTitle.vue';
import type { FontColorOption } from '@/typings/customilyElements/canvasElements';
import type { ColorObject } from '@/typings/libraries';


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarColorField',
  props: {
    value: { default: '#000000' },
    title: null,
    disabled: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'input', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string, title?: string, disabled?: boolean };





const { getColorFromString, hexToHexa } = useColor();

const color = computed<ColorObject>(() => {
    try {
        const parsed = getColorFromString(props.value);
        return { hex: parsed.hex, alpha: parsed.a, cmyk: '' };
    } catch {
        return { hex: '#000000', alpha: 1, cmyk: '' };
    }
});

const pickerRef: Ref<HTMLElement | undefined> = ref();

const { clickOutsideActive } = useClickOutside(
    pickerRef,
    () => {
        clickOutsideActive.value = false;
    },
    false
);

const togglePicker = () => {
    if (props.disabled) return;
    clickOutsideActive.value = !clickOutsideActive.value;
};

const onColorSelected = (selected: FontColorOption) => {
    const { hex, alpha } = selected as ColorObject;
    emit('input', alpha < 1 ? hexToHexa(hex, alpha) : hex);
    clickOutsideActive.value = false;
};

return { __sfc: true,props, emit, getColorFromString, hexToHexa, color, pickerRef, clickOutsideActive, togglePicker, onColorSelected, ColorSelector, CalendarFieldTitle }
}

})